import React from 'react'

import { Remarkable } from 'remarkable'

const Markdown = ({ markdown }) => {
  const markdownParser = new Remarkable({
    html: true,
    breaks: true
  })

  return(
    <div dangerouslySetInnerHTML={{__html: markdownParser.render(markdown)}}></div>
  )
}

export default Markdown
